import { render, staticRenderFns } from "./ProductQuantity.vue?vue&type=template&id=45c7c5e9&"
import script from "./ProductQuantity.vue?vue&type=script&lang=js&"
export * from "./ProductQuantity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../b_front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports